import '../../App.css';
import { Link, useParams } from "react-router-dom";
import { Container, Alert, Form, Button } from 'react-bootstrap';
import { Sida, Rubrik, ContentWrapper } from "../ContentStyles";
import useBackend, { CallAPI, Loading, SpinnerX } from '../../services/useBackend';
import {Branding} from '../../services/misc';

const Verify = () => {
  const {InstanceVerifyGUID} = useParams();
  const {loading, resultVariant, resultText, Refresh} =  useBackend('/backend/instance/Verify/'+InstanceVerifyGUID);

  if (!loading) {
    return (
      <ContentWrapper>
      <Container>
      <Sida>
          <Rubrik>Verifiera konto</Rubrik>

            <Alert variant={resultVariant} className="FormSpace">{resultText}</Alert>
            <Link to="/login"><Button className="QmeButton" style={{backgroundColor:Branding().ButtonColor}} variant="primary">Inloggning</Button></Link>        

      </Sida>
      </Container>
      </ContentWrapper>
    );
  } else {    
    return (<Loading />);        
  }
}

export default Verify;